import {lazy} from '@aboutyou/lazy-imports';
import React from 'react';
import {Skeleton} from './Skeleton';

export const RecommendationsView = lazy(
  () =>
    import('./RecommendationsView.eager').then(mod => ({
      default: mod.RecommendationsView,
    })),
  {
    fallback: <Skeleton />,
  },
);
